import React, {useContext, useEffect, useState} from 'react';
import {OrderViewContext} from "./OrderViewContext";
import {NoteBookReportContext} from "../AccountingCoding/NoteBookReport/NoteBookReportContext";
import _axios from "../../httpService";
import {prefixUrl} from "../../utils/utilsData";
import {toast} from "react-toastify";
import numericFunction from "../../utils/NumericFunction";
import {CalenderIcon} from "../../Assets/svg";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import numeric from "../../utils/NumericFunction";
import {formatToPersianAddComma} from "../../utils/CommaSeparator";

function FilterSectionOrderView(props) {

  const helper = useContext(OrderViewContext);
  const setData = helper.setData
  const data = helper.data

  const topFilter = data.filter;

  const [loader, setLoader] = useState(false)
  const [isOpenFilter, setIsOpenFilter] = useState(true)
  try {
    return (<div className={"filter__section"}>
      <div className={`my-2`}
           style={{
             transition: "all 0.3s", height: isOpenFilter ? 'fit-content' : 20, borderRadius: 10, // padding: isOpenFilter ? 20 : 0,
             // overflowY: "scroll",
           }}
      >

        <div className={'mb-3'}
             onClick={() => setIsOpenFilter(!isOpenFilter)}
        >
          {!isOpenFilter && <span className={'ps-2'}>
            <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
  <path
    d="M9.99959 14.0001C9.41626 14.0001 8.83293 13.7751 8.39126 13.3334L2.95795 7.90009C2.71629 7.65843 2.71629 7.25843 2.95795 7.01676C3.19962 6.77509 3.59962 6.77509 3.84129 7.01676L9.2746 12.4501C9.6746 12.8501 10.3246 12.8501 10.7246 12.4501L16.1579 7.01676C16.3996 6.77509 16.7996 6.77509 17.0413 7.01676C17.2829 7.25843 17.2829 7.65843 17.0413 7.90009L11.6079 13.3334C11.1663 13.7751 10.5829 14.0001 9.99959 14.0001Z"
    fill="#5D70B5"
  />
</svg>

          </span>}
          {isOpenFilter && <span className={'ps-2'}>
            <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
  <g id="arrow-down-1 10">
    <path
      id="Vector"
      d="M9.99959 5.99994C9.41626 5.99994 8.83293 6.22494 8.39126 6.66661L2.95795 12.0999C2.71629 12.3416 2.71629 12.7416 2.95795 12.9832C3.19962 13.2249 3.59962 13.2249 3.84129 12.9832L9.2746 7.54994C9.6746 7.14994 10.3246 7.14994 10.7246 7.54994L16.1579 12.9832C16.3996 13.2249 16.7996 13.2249 17.0413 12.9832C17.2829 12.7416 17.2829 12.3416 17.0413 12.0999L11.6079 6.66661C11.1663 6.22494 10.5829 5.99994 9.99959 5.99994Z"
      fill="#5D70B5"
    />
  </g>
</svg>
          </span>}

          فیلترها
        </div>
        {isOpenFilter && <>
          <div className={'d-flex flex-wrap overflow-scroll'} style={{gap: 20}}>
            <div className={"review__input"}>
              <label>از تاریخ </label>
              <div
                className="datePicker__review ltr d-flex"
              >
                <CalenderIcon/>
                <DatePicker
                  id={"dateHereForm"}
                  calendar={persian}
                  className="classNameOfDatePicker "
                  placeholder="تاریخ"
                  name={"bame"}
                  locale={persian_fa}
                  // ref={dateCal}
                  calendarPosition="bottom-right"
                  hideOnScroll
                  value={topFilter.startDate}
                  onChange={(DateObject) => {
                    console.log(DateObject)

                    if (DateObject) {
                      const temp = numeric.p2e(DateObject.toLocaleString());
                      setData({filter: {...data.filter, startDate: temp}})
                    } else {
                      setData({filter: {...data.filter, startDate: ""}})
                    }
                  }}
                />
              </div>
            </div>
            <div className={"review__input"}>
              <label>تا تاریخ</label>
              <div
                className="datePicker__review ltr d-flex"
              >
                <CalenderIcon/>
                <DatePicker
                  id={"dateHereForm"}
                  calendar={persian}
                  // className="classNameOfDatePicker "
                  placeholder="تاریخ"
                  name={"bame"}
                  locale={persian_fa}
                  // ref={dateCal}
                  calendarPosition="bottom-right"
                  hideOnScroll
                  value={topFilter.endDate}
                  onChange={(DateObject) => {
                    if (DateObject) {
                      const temp = numeric.p2e(DateObject.toLocaleString());
                      setData({filter: {...data.filter, endDate: temp}})
                    } else {
                      setData({filter: {...data.filter, endDate: ""}})
                    }
                  }}
                />
              </div>
            </div>
            <div className={'review__input '}>
              <label htmlFor="yearFiltersReview11">وضعیت پرداخت</label>
              <select
                className={'width__142'}
                id="yearFiltersReview11"
                value={topFilter.paymentStatus}
                onChange={e => {
                  const value = e.target.value
                  setData({filter:{...topFilter , paymentStatus: value}})
                }}
              >
                <option value="all">همه</option>
                {data.tableData.paymentStatusList?.map((v,index)=> {

                  return <option key={index} value={v.value}>{v.label}</option>
                })}
                {/*<option value={"پرداخت نشده"}>پرداخت نشده</option>*/}
                {/*<option value={"پرداخت شده"}>پرداخت شده</option>*/}
              </select>
            </div>
          </div>
          <ul className={"d-flex flex-wrap"}>{
              data?.tableData?.paymentStatusData?.map((v,index)=>{

                const  count = v?.count ? formatToPersianAddComma(v?.count) : 0
                return <li className={"mx-4"}>{v?.caption} : {count}</li>
              })
            }</ul>
        </>}

      </div>


    </div>);
  } catch (error) {
    return <>{error.toString()}</>
  }
}

export default FilterSectionOrderView;